export default {
  benchmarkMenu: [
    { name: 'Gemeente', target: 'getMunicipalityOptions' },
    { name: 'Netbeheerder', target: 'gridOperators' },
    { name: 'Type realisatieproces', target: 'getCategoryOptions' },
    { name: 'Aantal palen per RP', target: 'recordsByNumberOfChargingStations' }
  ],

  LocationPickerDiameter: 250,

  chargePointOperatorField: {
    type: 'string',
    title: 'CPO',
    format: 'select',
    options: [
      { value: 'e6a13c70-975c-4416-a143-6bcc269afd34', text: 'TotalEnergies' },
      { value: '3d555142-f1a7-435c-958f-f3135b955b3b', text: 'Engie' }
    ],
    disabled: false,
    placeholder: 'Selecteer CPO'
  },

  supportEmailAddress: 'support@evtools.nl'
};
